import { useTranslation } from 'react-i18next';
import { showColumns } from '../useColumns';
import { useDeleteById } from 'RestAPIs/useDeleteById';
import { showErrorSnackbar } from 'components/shared/Snackbar';
import { useState } from 'react';
import ConnectionDetailDrawer from '../ConnectionDetailDrawer';
import { IMPORT_EMPLOYEE_CONFIG } from 'RestAPIs/endpoints';
import { DataGrid } from 'components/shared/DataGrid';
import { ImportEmployeeSetting } from '../types';

type ConnectionGridProps = {
  connectionTable: ImportEmployeeSetting[];
  isFetching: boolean;
};
export const ConnectionGrid = ({
  connectionTable,
  isFetching
}: ConnectionGridProps) => {
  const { t } = useTranslation('common');
  const [openDetails, setOpenDetails] = useState<boolean>(false);
  const [rowData, setRowData] = useState();

  const connectionColumns = showColumns(t);

  const { mutateAsync: deleteRow } = useDeleteById(IMPORT_EMPLOYEE_CONFIG, [
    'importEmployeeConfig'
  ]);

  const handleDeleteRow = async (id) => {
    try {
      await deleteRow(id);
    } catch (e) {
      showErrorSnackbar();
    }
  };

  return (
    <>
      <DataGrid
        sx={{ marginTop: 2 }}
        onAddClick={() => {
          setOpenDetails(true);
          setRowData(undefined);
        }}
        onEditClick={(_, row) => {
          setOpenDetails(true);
          setRowData(row);
        }}
        columns={connectionColumns}
        rows={connectionTable}
        loading={isFetching}
        getRowId={(item) => item.impEmployeeConfigId}
        confirmationTitle={t('deleteDialog.title')}
        confirmationBody={t('deleteDialog.body')}
        onDeleteClick={(ids) => handleDeleteRow(ids)}
      />
      <ConnectionDetailDrawer
        tableRow={rowData}
        containerOpen={openDetails}
        handleClose={() => {
          setOpenDetails(false);
        }}
      />
    </>
  );
};
